import { render, staticRenderFns } from "./QmInfoSection.vue?vue&type=template&id=3138cf3b&"
import script from "./QmInfoSection.vue?vue&type=script&lang=js&"
export * from "./QmInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports